import selectInsurance from 'utils/selectInsurance';

const getConditionAutoAccident = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  if (selectedInsurance['Claim Filling Code'] && selectedInsurance['Claim Filling Code'].ID
    && selectedInsurance['Claim Filling Code'].ID === 3) {
    return 'Yes';
  }
  return 'No';
};

export default getConditionAutoAccident;



// WEBPACK FOOTER //
// ./src/utils/print/getConditionAutoAccident.js